module.exports = __webpack_public_path__ + "static/media/icon_education.5ea934b9.svg";